/**
 * Guest emails on meeting root from REST (`event_guest_emails`) or camel (`eventGuestEmails`).
 * Supergraph meeting detail often omits this field; entries may be strings or `{ email }`.
 *
 * When the root list is empty, non-group meetings may still list guests as `attendees` with
 * `kind: EXTERNAL` (same rows folded into `eventMemberships` in `mapNodeToMeeting`). We map
 * those to the same string[] shape as `eventGuestEmails` for UI and reschedule prefill.
 *
 * @param {Record<string, unknown> | null | undefined} meeting
 * @returns {string[]}
 */
const emailsFromRootFields = (meeting) => {
  const raw = meeting.event_guest_emails ?? meeting.eventGuestEmails ?? []
  if (!Array.isArray(raw)) return []
  return raw
    .map((e) => {
      if (typeof e === 'string') return e.trim()
      if (e && typeof e.email === 'string') return e.email.trim()
      return ''
    })
    .filter(Boolean)
}

const eventTypeKind = (meeting) => {
  const et = meeting.eventType ?? meeting.event_type
  return et && typeof et === 'object' ? et.kind : undefined
}

const emailsFromExternalAttendees = (meeting) => {
  const kind = String(eventTypeKind(meeting) ?? '').toLowerCase()
  if (kind === 'group') return []

  const attendees = meeting.attendees
  if (!Array.isArray(attendees)) return []

  return attendees
    .filter(
      (a) => a && typeof a === 'object'
        && !a.cancelled
        && String(a.kind ?? '').toUpperCase() === 'EXTERNAL'
        && typeof a.email === 'string'
    )
    .map((a) => a.email.trim())
    .filter(Boolean)
}

export const normalizeEventGuestEmails = (meeting) => {
  if (!meeting) return []
  const fromRoot = emailsFromRootFields(meeting)
  if (fromRoot.length > 0) return fromRoot
  return emailsFromExternalAttendees(meeting)
}
